import { useSelector } from "react-redux";
import "./profile-overview.scss";
import LogoutButton from "../LogoutButton";

const ProfileOverview = () => {
  const user = useSelector((state) => state.profile.user);

  return (
    <div className="profile-overview-container">
      <div
        style={{
          display: "flex",
          flexDirection: "row",
          alignItems: "space-between",
          justifyContent: "space-between",
          width: "100%",
        }}
      >
        <h5 className="profile-header">Profile</h5>
        <LogoutButton />
      </div>
      <p className="profile-subheader">UserName</p>
      <p className="profile-info-text">{user?.display_name}</p>
      <p className="profile-subheader">Full Name</p>
      <p className="profile-info-text">
        {user?.first_name + " " + user?.last_name}
      </p>
      <p className="profile-subheader">Email</p>
      <p className="profile-info-text">{user?.email}</p>
    </div>
  );
};
export default ProfileOverview;
